module.exports = `${require.publicPath}southbay-dark.01f45b53.webp`;